import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import {
  Button,
  Col,
  DatePicker,
  PageHeader,
  Radio,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import { LanguageContext } from "../../context/LanguageContext";
import moment from "moment";
import { PoliceSideActions } from "../../_actions/police.side.actions";
import * as XLSX from "xlsx-js-style";
import { professionalAction } from "../../_actions";
import { ArrestReportAdmin } from "./ArrestReportAdmin";
const { Option } = Select;

class CctnsArrestRegister extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }
  state = {
    type: "cmis",
    report_4_startDate: "",
    report_4_endDate: "",
    download: "excel",
    data: [],
    loading: false,
    pagination: {
      current: 1,
      pageSize: 10,
      showSizeChanger: true,
      pageSizeOptions: ["10", "20", "50", "100"],
    },
  };
  onChangeType = (value) => {
    this.setState({
      type: value,
    });
  };
  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.toISOString();

      this.setState({
        report_4_startDate: startDate,
        report_4_endDate: null, // reset end date when start changes
        isMoreThanOneYear: false,
      });
    } else {
      this.setState({
        report_4_startDate: null,
        report_4_endDate: null,
        isMoreThanOneYear: false,
      });
    }
  };

  onEndDateChange = (date) => {
    if (!date) return;

    this.setState({
      report_4_endDate: date.toISOString(),
    });
  };

  getGunaCctnsData = () => {
    this.setState({
      loading: true,
    });
    const { user } = this.props;
    const { report_4_startDate, report_4_endDate } = this.state;
    const temp = {
      district: user.districtId,
      startDate: moment(report_4_startDate).format("YYYY-MM-DD"),
      endDate: moment(report_4_endDate).format("YYYY-MM-DD"),
    };
    PoliceSideActions.getArestCctnsData(temp).then((res) => {
      console.log("RES", res);
      this.setState({
        data: res.data,
        loading: false,
      });
    });
  };

  handleTableChange = (pagination) => {
    this.setState((prevState) => ({
      pagination: {
        ...prevState.pagination,
        ...pagination,
      },
    }));
  };

  downloadReport = () => {
    const { download } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
  };

  getDistrictsid = (id) => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };

  componentDidMount = () => {
    const { user } = this.props;
    if (user && user.role !== "4") {
      this.getDistrictsid();
    }
  };
  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };
  download_csv = () => {
    const { t } = this.context;
    var ReportTitle = t("arrest_register_report");
    var title = `${t("arrest_register_report")}`;
    var arrData1 = this.state.data;
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const list = arrData1.map((data, index) => ({
      [t("sr.no")]: index + 1,
      [t("accused_name")]: data.person_full_name,
      [t("gender")]: data.gender,
      [t("age")]: data.age,
      [t("crime_register_number")]: data.registernumber,
      [t("crime_register_year")]: data.registernumberyear,
      [t("arrest_datetime")]: moment(data.arrested_datetime).format(
        "DD-MM-YYYY",
      ),
    }));

    const arrData = list;

    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName = this.getCityName(this.props?.user?.cityId || "");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = {
      v: `From: ${
        moment(this.state.report_4_startDate).format("DD-MM-YYYY") || "-"
      } To ${moment(this.state.report_4_endDate).format("DD-MM-YYYY") || "-"}`,
      t: "s",
    };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };
  render() {
    const { user } = this.props;
    console.log("user", user);
    const {
      type,
      report_4_endDate,
      report_4_startDate,
      data,
      pagination,
      loading,
    } = this.state;
    const { t } = this.context;
    const columns = [
      {
        title: t("sr.no"),
        dataIndex: "srNo",
        key: "srNo",
        render: (_, __, rowIndex) =>
          (pagination.current - 1) * pagination.pageSize + rowIndex + 1,
      },
      {
        title: t("accused_name"),
        dataIndex: "person_full_name",
        key: "person_full_name",
        sorter: (a, b) => a.person_full_name - b.person_full_name,
      },
      {
        title: t("gender"),
        dataIndex: "gender",
        key: "gender",
      },
      {
        title: t("age"),
        dataIndex: "age",
        key: "age",
      },
      {
        title: t("crime_register_number"),
        dataIndex: "registernumber",
        key: "registernumber",
        sorter: (a, b) => a.registernumber - b.registernumber,
      },
      {
        title: t("crime_register_year"),
        dataIndex: "registernumberyear",
        key: "registernumberyear",
        render: (text, record) => (
          <Space size="middle" title={record?.id} style={{ maxWidth: 300 }}>
            {record.registernumberyear}
          </Space>
        ),
      },
      {
        title: t("arrest_datetime"),
        dataIndex: "arrested_datetime",
        key: "arrested_datetime",
        render: (text, record) => (
          <Space size="middle" title={record?.id} style={{ maxWidth: 300 }}>
            {moment(record.arrested_datetime).format("DD-MM-YYYY")}
          </Space>
        ),
      },
    ];

    return (
      <>
        <div
          style={{
            marginBottom: 16,
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}
        >
          <span style={{ fontWeight: 600 }}>Report Source:</span>
          <Radio.Group
            value={type}
            buttonStyle="solid"
            onChange={(e) => this.onChangeType(e.target.value)}
          >
            <Radio.Button value="cmis">CMIS</Radio.Button>
            <Radio.Button value="cctns">CCTNS</Radio.Button>
          </Radio.Group>
        </div>

        {type === "cmis" && <ArrestReportAdmin />}

        {type === "cctns" && (
          <>
            <PageHeader
              className="site-page-header"
              ghost={false}
              onBack={false}
            >
              <Row
                gutter={[16, 16]}
                align="middle"
                style={{ marginBottom: "10px" }}
              >
                {/* Start Date Picker */}
                <Col xs={24} sm={12} md={6} lg={4}>
                  <DatePicker
                    style={{ width: "100%" }}
                    value={
                      report_4_startDate ? moment(report_4_startDate) : null
                    }
                    onChange={this.onStartDateChange}
                    placeholder="DD/MM/YYYY"
                    allowClear
                    format="DD/MM/YYYY"
                    inputReadOnly
                  />
                </Col>

                {/* End Date Picker */}
                <Col xs={24} sm={12} md={6} lg={4}>
                  <DatePicker
                    style={{ width: "100%" }}
                    value={report_4_endDate ? moment(report_4_endDate) : null}
                    onChange={this.onEndDateChange}
                    placeholder="DD/MM/YYYY"
                    allowClear
                    format="DD/MM/YYYY"
                    inputReadOnly
                  />
                </Col>

                {/* Find Button */}
                <Col xs={24} sm={24} md={6} lg={3}>
                  <Button
                    type="primary"
                    style={{ width: "100%" }}
                    disabled={
                      !this.state.report_4_startDate ||
                      !this.state.report_4_endDate
                    }
                    onClick={this.getGunaCctnsData}
                  >
                    {t("find")}
                  </Button>
                </Col>

                {/* Download Select */}
                <Col xs={24} sm={12} md={4} lg={4}>
                  <Select
                    placeholder={t("please_select_an_option")}
                    value={this.state.download || "excel"}
                    onChange={(value) => this.setState({ download: value })}
                    style={{ width: "100%" }}
                  >
                    <Option key="excel">{t("excel")}</Option>
                  </Select>
                </Col>

                {/* Download Button */}
                <Col xs={12} sm={6} md={2} lg={4}>
                  <Button
                    type="primary"
                    style={{ width: "100%" }}
                    onClick={this.downloadReport}
                    disabled={!this.state.data?.length}
                  >
                    {t("download")}
                  </Button>
                </Col>
              </Row>
              <div style={{ marginBottom: 16 }}>
                <div className="stats-card stats-photo">
                  <span className="stats-text">
                    {t("guna_count")}: {data.length || 0}
                  </span>
                </div>
              </div>

              <Table
                bordered
                loading={loading}
                scroll={{ x: "max-content" }}
                columns={columns}
                dataSource={data}
                rowClassName={() => "govt-table-row"}
                pagination={{
                  ...pagination,
                  total: data.length,
                  showTotal: (total) => `Total ${total} states`,
                }}
                onChange={this.handleTableChange}
              />
            </PageHeader>
          </>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connecteCctnsArrestRegister =
  connect(mapStateToProps)(CctnsArrestRegister);
export { connecteCctnsArrestRegister as CctnsArrestRegister };
